import React from 'react';
import { useLocation } from 'react-router-dom';
import '../assets/css/whatsapp-button.css';

const WhatsAppButton: React.FC = () => {
    const location = useLocation();
    const phoneNumber = '34614005838'; // WhatsApp number format without + or spaces
    const defaultMessage = 'Hello! I would like to get a quote for your services.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`;

    // Hide WhatsApp button on CMS, login, register, and backoffice pages
    const hiddenPaths = ['/cms', '/login', '/register', '/backoffice', '/forgot-password', '/reset-password', '/auth'];
    const shouldHide = hiddenPaths.some(path => location.pathname.startsWith(path));

    if (shouldHide) {
        return null;
    }

    return (
        <a
            href={whatsappUrl}
            className="whatsapp-float"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Contact us on WhatsApp"
            title="Contact us on WhatsApp"
        >
            <i className="fa fa-whatsapp"></i>
        </a>
    );
};

export default WhatsAppButton;
